import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Title from '../../../../../@casino/ui/title';
import { setGetCreditLimits } from '../../store/thunk/setGetCreditLimits';
import { setGetListGroups } from '../../store/thunk/setGetListGroups';
import {useRouter} from '../../../../../@casino/useRouter'
import { setGetCreditLive } from '../../store/thunk/setGetCreditLive';

const CreditList = () => {
    const dispatch = useDispatch();
    const router = useRouter();

    React.useEffect(() => {
        dispatch(setGetCreditLimits());
        dispatch(setGetCreditLive());
        dispatch(setGetListGroups({ group: '', hide: false}))
    }, []);

    const credit = useSelector(state => state.credit.list);
    const groups = useSelector(state => state.credit.groups);
    const creditLive = useSelector(state => state.credit.live);
  
    return (
        <div style={{padding: 20, paddingTop: 0}}>
            <Title label="Кредитная линия"/>
            {
                credit.map((item) => {
                    return (
                        <div style={{
                            padding: 20, 
                            background: '#1b2039', 
                            borderRadius: 8, 
                            marginBottom: 12
                        }}>
                            <div style={{
                                padding: 10,
                                background: '#141b33',
                                paddingLeft: 10,
                                border: '1px solid #141b33',
                                color: '#fff',
                                outline: 'none',
                                // margin: 10,
                                width: 'calc(100% - 20px)',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <h3 style={{margin: 0, padding: 0, color: '#fff', userSelect: 'none', fontSize: 24}}>Кредиты </h3>
                                <span style={{marginRight: 10, marginLeft: 10, color: '#fff', fontWeight: 700}}>—</span>
                                <span style={{margin: 0, padding: 0, userSelect: 'none', fontSize: 24, fontWeight: 700, color: 'gold'}}>
                                    {new Intl.NumberFormat('ru-RU').format(Math.floor(item?.amount*100)/100)} {item?.currency}
                                </span>
                            </div>
                            <div style={{marginTop: 12}}>
                                <span style={{margin: 0, padding: 0, color: '#fff', userSelect: 'none', fontSize: 18, fontWeight: 700}}>Список провайдеров</span>
                            </div>
                            <div style={{marginTop: 20, display: 'flex', gap: 10, flexWrap: 'wrap'}}>
                                {
                                    item.providers?.map((data) => {
                                        return (
                                            <span style={{color: '#fff', fontWeight: 500, fontSize: 18, border: '1px solid #eee', borderRadius: 4, padding: '10px 20px', cursor: 'pointer'}}>{data}</span>
                                        )
                                    })
                                }
                                
                            </div>
                        </div>
                    )
                })
            }
            <div style={{display: 'flex', justifyContent: 'space-between', columnGap: 12}}>
                <div style={{
                    padding: 20, 
                    background: '#1b2039', 
                    borderRadius: 8, 
                    marginBottom: 12,
                    width: '50%'
                }} >
                    <div>
                        <span style={{fontSize: 20, color: '#fff', textTransform: 'uppercase', fontWeight: 700}}>
                            Кредиты для пользователей:  <span style={{color: 'gold'}}>{new Intl.NumberFormat('ru-RU').format(credit.length ? credit[0].amount - groups.summ : 0)} ₽</span></span>
                    </div>
                </div>
                <div style={{
                    padding: 20, 
                    background: '#1b2039', 
                    borderRadius: 8, 
                    marginBottom: 12,
                    width: '50%'
                }}>
                    <div>
                        <span style={{fontSize: 20, color: '#fff', textTransform: 'uppercase', fontWeight: 700}}>Кредиты на кассах:  <span style={{color: 'gold'}}>{new Intl.NumberFormat('ru-RU').format(groups.summ)} ₽</span></span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', marginTop: 10}}>
                        {
                            groups.list.map((item, key) => (
                                <span 
                                    style={{color: '#fff', fontSize: 18, cursor: 'pointer'}}
                                    onClick={() => {
                                        router.history.push(`/cashier/group/${item.id}`)
                                    }}
                                >
                                    <span style={{color: 'gold', fontWeight: 700}}>&mdash;</span> {item.groups} (<span style={{color: 'gold'}}>{item.balance ? item.balance.toFixed(2) : item.balance} ₽</span>)
                                </span>
                            ))
                        }
                    </div>
                </div>
            </div>
            {
                creditLive.map((item) => {
                    return (
                        <div style={{
                            padding: 20, 
                            background: '#1b2039', 
                            borderRadius: 8, 
                            marginBottom: 12
                        }}>
                            <div style={{
                                padding: 10,
                                background: '#141b33',
                                paddingLeft: 10,
                                border: '1px solid #141b33',
                                color: '#fff',
                                outline: 'none',
                                // margin: 10,
                                width: 'calc(100% - 20px)',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <h3 style={{margin: 0, padding: 0, color: '#fff', userSelect: 'none', fontSize: 24}}>Кредиты </h3>
                                <span style={{marginRight: 10, marginLeft: 10, color: '#fff', fontWeight: 700}}>—</span>
                                <span style={{margin: 0, padding: 0, userSelect: 'none', fontSize: 24, fontWeight: 700, color: 'gold'}}>
                                    {new Intl.NumberFormat('ru-RU').format(Math.floor(item.amount*100)/100)} {item.currency}
                                </span>
                            </div>
                            <div style={{marginTop: 12}}>
                                <span style={{margin: 0, padding: 0, color: '#fff', userSelect: 'none', fontSize: 18, fontWeight: 700}}>Список провайдеров</span>
                            </div>
                            <div style={{marginTop: 20, display: 'flex', gap: 10, flexWrap: 'wrap'}}>
                                {
                                    item.providers?.map((data) => {
                                        return (
                                            <span style={{color: '#fff', fontWeight: 500, fontSize: 18, border: '1px solid #eee', borderRadius: 4, padding: '10px 20px', cursor: 'pointer'}}>{data}</span>
                                        )
                                    })
                                }
                                
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default CreditList;